export default {
    namespaced: true,
    state: {
        contactFilter: {}
    },
    getters: {
        getContactFilter: state => state.contactFilter
    },
    mutations: {
        setContactFilter (state, contactFilter) {
            state.contactFilter = contactFilter;
        }
    },
    actions: {
    }
}